import filterItems, { filterItem } from './filterItems';
import {
  getIndexDropdownMenuItemsConfig,
  getProductsDropdownMenuItemsConfig,
  getIndexMenuItemsConfig,
  getProductsMenuItemsConfig,
} from './getDefaultItems';

export default {
  filterItem,
  filterItems,
  getIndexDropdownMenuItemsConfig,
  getProductsDropdownMenuItemsConfig,
  getIndexMenuItemsConfig,
  getProductsMenuItemsConfig,
};
